
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./platforms.web.cjs.production.min.js')
} else {
  module.exports = require('./platforms.web.cjs.development.js')
}
